import React, { memo, useEffect, useRef, useState, forwardRef, useCallback, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import clsx from "clsx";
import ResizeObserver from "react-resize-observer";

import { FixedSizeList, VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";
import { isMobile } from "react-device-detect";

import { HighlightSpan } from "./PriceBoardTotalMode";
//
import { changeSortConfig, addFavSymbol, removeFavSymbol, changeSelectShowInfo, showPopupInfo, removeFindSymbol } from "../redux/actions/sharedActions";

import { formatQtty, formatNumberToM, formatNumber, formatNumberPS , formatNumberPS_AVGPrice} from "../helpers/utils";
import CandleStickHistChart from "./share-components/CandleStickHistChart";
import StockDerivativeDetail from "./stock-components/StockDerivativeDetail";
import StockMatchDetailV2 from "./stock-components/StockMatchDetailV2";
import StockMatchDetail_Der from "./stock-components/StockMatchDetail_Der";

export default memo(function PriceBoardDerivative(props) {
  const { symbolInfos } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  //
  const [headerRowPos, setHeaderRowPos] = useState(null);

  const [bidPrice3Pos, setBidPrice3Pos] = useState(null);
  const [bidQtty1Pos, setBidQtty1Pos] = useState(null);

  const [offerPrice1Pos, setOfferPrice1Pos] = useState(null);
  const [offerQtty3Pos, setOfferQtty3Pos] = useState(null);

  const [offerMatchPosStart, setOfferMatchPosStart] = useState(null);
  const [offerMatchPosEnd, setOfferMatchPosEnd] = useState(null);

  const [showTotalValue, setShowTotalValue] = useState(false);

  //
  const refHeaderFix = useRef(null);
  const refScrollBody = useRef(null);

  const refBid = useRef(null);
  const refOffer = useRef(null);
  const refMatch = useRef(null);

  const measureRefBid = useCallback((node) => {
    if (node !== null) {
      refBid.current = node;
    }
  }, []);

  //
  const measureRefOffer = useCallback((node) => {
    if (node !== null) {
      refOffer.current = node;
    }
  }, []);

  const measureRefMatch = useCallback((node) => {
    if (node !== null) {
      refMatch.current = node;
    }
  }, []);

  const _handleChangeShowTotalValue = () => {
    if (showTotalValue) {
      setShowTotalValue(false);
    } else {
      setShowTotalValue(true);
    }
  };

  //
  const _handleHeaderScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      if (refScrollBody.current) {
        // refScrollBody.current.scrollBody.scrollLeft(scrollLeft);
      }
    },
    [refScrollBody.current]
  );

  const _handleBobyScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      refHeaderFix.current.scrollLeft = scrollLeft;
    },
    [refHeaderFix.current]
  );

  const _calcDivBidPosition = () => {
    if (headerRowPos && bidPrice3Pos && bidQtty1Pos && refBid.current) {
      const _left = bidPrice3Pos.x - headerRowPos.x;
      const _width = bidQtty1Pos.x - bidPrice3Pos.x + bidQtty1Pos.width;
      refBid.current.style.left = _left + "px";
      refBid.current.style.width = _width + "px";
    }
  };

  const _calcDivOfferPosition = () => {
    if (headerRowPos && offerPrice1Pos && offerQtty3Pos && refOffer.current) {
      const _left = offerPrice1Pos.x - headerRowPos.x;
      const _width = offerQtty3Pos.x - offerPrice1Pos.x + offerQtty3Pos.width;
      refOffer.current.style.left = _left + "px";
      refOffer.current.style.width = _width + "px";
    }
  };

  const _calcDivMatchPosition = () => {
    if (headerRowPos && offerMatchPosStart && offerMatchPosEnd && refMatch.current) {
      const _left = offerMatchPosStart.x - headerRowPos.x;
      const _width = offerMatchPosEnd.x - offerMatchPosStart.x + offerMatchPosEnd.width;
      refMatch.current.style.left = _left + "px";
      refMatch.current.style.width = _width + "px";
    }
  };

  useEffect(() => {
    _calcDivBidPosition();
  }, [headerRowPos, bidPrice3Pos, bidQtty1Pos, refBid.current]);

  useEffect(() => {
    _calcDivOfferPosition();
  }, [headerRowPos, offerPrice1Pos, offerQtty3Pos, refOffer.current]);

  useEffect(() => {
    _calcDivMatchPosition();
  }, [headerRowPos, offerMatchPosStart, offerMatchPosEnd, refMatch.current]);

  //
  return (
    <>
      <AutoSizer disableHeight>
        {({ height, width }) => {
          return (
            <div style={{ width: width }}>
              <div ref={refHeaderFix} onScroll={_handleHeaderScroll} style={{ width: width, overflowX: "scroll", overflowY: "hidden", marginBottom: isMobile ? 0 : -10 }}>
                <div className="prc-row-head prc-row-head-spec">
                  <ResizeObserver
                    onResize={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                    onPosition={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                    onReflow={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                  />
                  <div className={clsx("prc-col4 text-center mw-90 mxw-90 bdl-white")}>{t("maHopDong_S")}</div>
                  <div className={clsx("prc-col2 mw-85 mxw-85 text-center")}>{t("ngayNgaoHan_S")}</div>
                  <div className={clsx("prc-col text-center")}>{t("tran")}</div>
                  <div className={clsx("prc-col text-center ")}>{t("san")}</div>
                  <div className={clsx("prc-col text-center ")}>{t("tc")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center bdl-white")}>
                    {t("gia3")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                    />
                  </div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("kl3")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("gia2")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("kl2")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("gia1")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>
                    {t("kl1")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                    />
                  </div>
                  <div ref={measureRefBid} className={"prc-col-cs prc-col-bid bdl-white"}>
                    {t("muaPhaiSinh")}
                  </div>
                  {/* Khớp */}
                  <div className={clsx("prc-col-rs prc-col text-center bdl-white")}>
                    {t("giaKhop")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                    />
                  </div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("klKhop")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>+/-</div>
                  <div className="prc-col-rs prc-col2 d-flex ">
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                    />
                    <div className="d-flex align-items-center h-100 pdr-3 pr-icon-btn" onClick={_handleChangeShowTotalValue}>
                      <i className="fas fa-caret-left"></i>
                    </div>
                    {showTotalValue ? (
                      <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100")}>{t("tongGTKhop")}</div>
                    ) : (
                      <div className={clsx("flex-1 d-flex align-items-center justify-content-center text-center h-100")}>{t("tongKLKhop")}</div>
                    )}
                    <div className="d-flex align-items-center h-100 pdl-3 pr-icon-btn" onClick={_handleChangeShowTotalValue}>
                      <i className="fas fa-caret-right"></i>
                    </div>
                  </div>
                  <div ref={measureRefMatch} className={" prc-col-cs prc-col-match bdl-white"}>
                    {t("khopPhaiSinh")}
                  </div>
                  {/* END khớp */}
                  <div className={clsx("prc-col-rs prc-col text-center bdl-white")}>
                    {t("gia1")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferPrice1Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferPrice1Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferPrice1Pos(rect);
                      }}
                    />
                  </div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("kl1")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("gia2")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("kl2")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>{t("gia3")}</div>
                  <div className={clsx("prc-col-rs prc-col text-center")}>
                    {t("kl3")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferQtty3Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferQtty3Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferQtty3Pos(rect);
                      }}
                    />
                  </div>
                  <div ref={measureRefOffer} className={"prc-col-cs prc-col-ask bdl-white"}>
                    {t("banphaiSinh")}
                  </div>
                  <div className={clsx("prc-col text-center bdl-white")}>{t("doLech")}</div>
                  <div className={clsx("prc-col text-center")}>{t("klMo")} (OI)</div>
                  <div className={clsx("prc-col text-center")}>{t("thayDoi")} (OI)</div>
                  <div className={clsx("prc-col text-center bdl-white")}>{t("caoNhat")}</div>
                  <div className={clsx("prc-col text-center")}>{t("giaTB")}</div>
                  <div className={clsx("prc-col text-center")}>{t("thapNhat")}</div>
                </div>
              </div>
            </div>
          );
        }}
      </AutoSizer>
      <div className={"price-board"}>
        <TableBody ref={refScrollBody} symbolInfos={symbolInfos} onScroll={_handleBobyScroll} showTotalValue={showTotalValue} />
      </div>
    </>
  );
});

//
const TableBody = forwardRef((props, ref) => {
  //
  const { symbolInfos, onScroll, showTotalValue } = props;
  //
  const dispatch = useDispatch();
  const findSymbol = useSelector((state) => state.gShared.findSymbol);
  //
  const refTable = useRef(null);
  const refScroll = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollBody: refScroll.current,
    scrollToItem: (itemIdx) => {
      if (refTable.current) {
        refTable.current.scrollToItem(itemIdx);
      }
    },
  }));
  //
  const _handleScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      if (refTable.current) {
        refTable.current.scrollTo(scrollTop);
      }
      //
      if (onScroll) {
        try {
          onScroll({ target });
        } catch (error) {}
      }
    },
    [refTable.current]
  );

  const _handleTableScroll = useCallback(
    ({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
      if (refScroll.current) {
        refScroll.current.scrollTop(scrollOffset);
      }
      if (findSymbol && findSymbol.code && findSymbol.code !== "") {
        removeFindSymbol(dispatch, "");
      }
    },
    [refScroll.current]
  );

  const _scrollToSymbol = () => {
    if (refTable.current) {
      if (findSymbol && findSymbol.code && findSymbol.code !== "" && symbolInfos && symbolInfos.length > 0) {
        const _idx = symbolInfos.findIndex((e) => e.code === findSymbol.code);
        if (_idx >= 0) {
          if (refTable.current) {
            refTable.current.scrollToItem(_idx, "start");
          }
        }
      }
    } else {
      setTimeout(() => {
        _scrollToSymbol();
      }, 100);
    }
  };

  useEffect(() => {
    _scrollToSymbol();
  }, [findSymbol.counter, symbolInfos.length]);

  //
  return (
    <AutoSizer>
      {({ height, width }) => {
        return (
          <Scrollbars
            ref={refScroll}
            autoHide={true}
            autoHeight={true}
            autoHeightMax={height}
            onScroll={_handleScroll}
            style={{ width: width }}
            renderTrackHorizontal={(props) => <div {...props} className="scroll-track-horizontal" />}
            renderTrackVertical={(props) => <div {...props} className="scroll-track-vertical" />}
            renderThumbHorizontal={(props) => <div {...props} className="scroll-thumb-horizontal" />}
            renderThumbVertical={(props) => <div {...props} className="scroll-thumb-vertical" />}
            renderView={(props) => <div {...props} className="scroll-view" />}
            className={"scroll-container"}>
            <ScrollContent symbolInfos={symbolInfos} height={height} onScroll={_handleTableScroll} showTotalValue={showTotalValue} ref={refTable} />
          </Scrollbars>
        );
      }}
    </AutoSizer>
  );
});

//
const ScrollContent = memo(
  forwardRef(function (props, ref) {
    const { symbolInfos, height, onScroll, showTotalValue } = props;
    //

    const [selectedRow, setSelectedRow] = useState(null); // Trạng thái để theo dõi dòng được chọn

    const handleRowClick = (index) => {
      if (selectedRow === index) {
        setSelectedRow(null); // Nếu click vào dòng đã chọn, ẩn div đi
      } else {
        setSelectedRow(index); // Nếu click vào dòng mới, hiển thị div mới
      }
    };

    const itemSizes = Array.from({ length: symbolInfos.length }, (_, index) => {
      ref?.current?.resetAfterIndex(0);
      return selectedRow === index ? 390 : 29;
    });

    return (
      <>
        <VariableSizeList ref={ref} height={height} width={"100%"} itemCount={symbolInfos.length} itemSize={(index) => itemSizes[index]} style={{ overflow: false }} onScroll={onScroll}>
          {({ index, style }) => {
            const _symbolInfo = symbolInfos[index];
            return (
              <div>
                <RowFlex
                  className={"prc-row " + (index % 2 === 0 ? "odd" : "even")}
                  counter={_symbolInfo.counter}
                  code={_symbolInfo.code}
                  showTotalValue={showTotalValue}
                  rowClick={() => handleRowClick(index)}
                  style={{ ...style }}
                  selectedRow={selectedRow}
                  index={index}
                />
              </div>
            );
          }}
        </VariableSizeList>
      </>
    );
  })
);

//
const RowFlex = memo(function (props) {
  const { code, showTotalValue } = props;
  //
  const dispatch = useDispatch();
  const prevSymbolCode = useRef(""); // .current

  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("1");

  const tabIsFocus = useSelector((state) => state.gShared.tabIsFocus);
  const counter = useSelector((state) => state.gSymbol.symbolInfos.find((e) => e.code === code).counter);
  const symbolInfo = useSelector((state) => state.gSymbol.symbolInfos.find((e) => e.code === code));

  const _fireEvent = prevSymbolCode.current === symbolInfo.code && tabIsFocus;
  //
  const _handleRowClick = useCallback((event, code) => {
    if (code) {
      if (code + "_code" === event.target.id) {
        showPopupInfo(dispatch, "ST", code);
      } else if (code + "_star" === event.target.id) {
        //
      } else {
        changeSelectShowInfo(dispatch, "ST", code);
      }
    }
  }, []);
  //
  useEffect(() => {
    prevSymbolCode.current = symbolInfo.code;
  }, [symbolInfo.code]);

  return (
    <div style={{ ...props.style }}>
      <div onClick={() => props.rowClick()} className={props.className} >
        <div className="prc-col4 text-left mw-90 mxw-90" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? "") + " - " + symbolInfo.marketName}>
          <span style={{ cursor: "pointer" }} id={symbolInfo.code + "_code"}  >
            {symbolInfo.code}
          </span>
        </div>

        <div className={clsx("prc-col2  mw-85 mxw-85 text-center")}>
          <HighlightSpan id={symbolInfo.code + "_lastTradingDate"} value={symbolInfo.lastTradingDate} fireEvent={_fireEvent} />
        </div>

        <div className="prc-col text-right clr-ceil">
          <HighlightSpan id={symbolInfo.code + "_ceilPrice"} value={formatNumberPS(symbolInfo.ceilPrice)} fireEvent={_fireEvent} />
        </div>
        <div className="prc-col text-right clr-floor">
          <HighlightSpan id={symbolInfo.code + "_floorPrice"} value={formatNumberPS(symbolInfo.floorPrice)} fireEvent={_fireEvent} />
        </div>
        <div className="prc-col text-right clr-ref">
          <HighlightSpan id={symbolInfo.code + "_refPrice"} value={formatNumberPS(symbolInfo.refPrice)} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col-rs prc-col text-right bdl-white", symbolInfo.bidPrice3_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidPrice3"} value={formatNumberPS(symbolInfo.bidPrice3)} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col text-right", symbolInfo.bidPrice3_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidQtty3"} value={(symbolInfo.bidQtty3)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.bidPrice2_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidPrice2"} value={formatNumberPS(symbolInfo.bidPrice2)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.bidPrice2_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidQtty2"} value={(symbolInfo.bidQtty2)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.bidPrice1_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidPrice1"} value={formatNumberPS(symbolInfo.bidPrice1)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.bidPrice1_color)}>
          <HighlightSpan id={symbolInfo.code + "_bidQtty1"} value={(symbolInfo.bidQtty1)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right bdl-white", symbolInfo.matchPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_matchPrice"} value={formatNumberPS(symbolInfo.matchPrice)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.matchPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_changePrice"} value={symbolInfo.matchQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.matchPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_matchQtty"} value={(symbolInfo.changePrice)} fireEvent={_fireEvent} />
        </div>

        {showTotalValue ? (
          <div className={clsx("prc-col2 text-right")}>
            <HighlightSpan id={symbolInfo.code + "_totalTradedValueNM"} value={(symbolInfo.totalTradedValueNM)} fireEvent={_fireEvent} />
          </div>
        ) : (
          <div className={clsx("prc-col2 text-right")}>
            <HighlightSpan id={symbolInfo.code + "_totalTradedQttyNM"} value={formatNumberPS(symbolInfo.totalTradedQttyNM)} fireEvent={_fireEvent} />
          </div>
        )}

        {/* END khớp */}
        <div className={clsx("prc-col text-right bdl-white", symbolInfo.offerPrice1_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerPrice1"} value={formatNumberPS(symbolInfo.offerPrice1)} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col text-right", symbolInfo.offerPrice1_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerQtty1"} value={(symbolInfo.offerQtty1)} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col text-right", symbolInfo.offerPrice2_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerPrice2"} value={formatNumberPS(symbolInfo.offerPrice2)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.offerPrice2_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerQtty2"} value={(symbolInfo.offerQtty2)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.offerPrice3_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerPrice3"} value={formatNumberPS(symbolInfo.offerPrice3)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.offerPrice3_color)}>
          <HighlightSpan id={symbolInfo.code + "_offerQtty3"} value={(symbolInfo.offerQtty3)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right bdl-white", symbolInfo.basis_color)}>
          <HighlightSpan id={symbolInfo.code + "_basis"} value={(symbolInfo.basis)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right")}>
          <HighlightSpan id={symbolInfo.code + "_openInterest"} value={formatNumberPS(symbolInfo.openInterest)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right")}>
          <HighlightSpan id={symbolInfo.code + "_openInterestChange"} value={formatNumberPS(symbolInfo.openInterestChange)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right bdl-white", symbolInfo.highestPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_highestPrice"} value={formatNumberPS(symbolInfo.highestPrice)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.avgPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_avgPrice"} value={formatNumberPS_AVGPrice(symbolInfo.avgPrice/100)} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col text-right", symbolInfo.lowestPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_lowestPrice"} value={formatNumberPS(symbolInfo.lowestPrice)} fireEvent={_fireEvent} />
        </div>
      </div>
      {props.selectedRow == props.index && (
        <div style={{ width: "100%", height: "100%" }} className="derivative">
          <div className="derivative__chart">
            <div className="d-flex justify-content-end mb-3">
              <a>{t("bieuDoKyThuat")}</a>
            </div>
            <StockDerivativeDetail symbolInfo={symbolInfo} />
          </div>

          <div className="derivative__infor">
            <div className="derivative__action">
              <button className={`${activeTab === "1" ? "active" : ""}`} onClick={() => setActiveTab("1")}>
                Bước giá
              </button>
              <button className={`${activeTab === "2" ? "active" : ""}`} onClick={() => setActiveTab("2")}>
                Lịch sử khớp lệnh
              </button>
            </div>

            {activeTab === "1" ? (
              <div className="derivative__step h-100">
                <AutoSizer>
                  {({ height, width }) => {
                    return (
                      <div className="tbl__popup" style={{ height: height, width: width }}>
                        <div className="tab-body-right d-flex flex-column" style={{ height: height }}>
                          <StockMatchDetail_Der
                            style={{ height: "100%", flex: 1 }}
                            symbolInfo={symbolInfo}
                            isDerivative={true}
                          />
                        </div>
                      </div>
                    );
                  }}
                </AutoSizer>
              </div>
            ) : (
              <div className="derivative__his h-100">
                <AutoSizer>
                  {({ height, width }) => {
                    return (
                      <div className="tbl__popup" style={{ height: height, width: width }}>
                        <div className="tab-body-right d-flex flex-column" style={{ height: height - 90 }}>
                          <StockMatchDetailV2
                            style={{ height: "100%", flex: 1 }}
                            code={symbolInfo.code}
                            refPrice={symbolInfo.refPrice}
                            floorPrice={symbolInfo.floorPrice}
                            ceilPrice={symbolInfo.ceilPrice}
                            isDerivative={true}
                          />
                        </div>
                      </div>
                    );
                  }}
                </AutoSizer>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});
